module.exports = __webpack_public_path__ + "media/images/social_svgs/tiktok-fec9fe6c538986a6892524a353aada47.svg";